import { Outlet } from "react-router-dom";
import { useLayoutStore } from "../../context";
import { classNames } from "../../utils/helpers";
import { SideNavMenu, TopNavMenu } from "../Menus";

/**
 * AuthLayout — Admin dashboard layout with TCSB sidebar and top nav.
 * Uses the sgb template sidebar collapse pattern with TCSB theming.
 */
export default function AuthLayout() {
  const [sidebarMenuOpen] = useLayoutStore((state) => [state.sidebarMenuOpen]);

  return (
    <div className="min-h-screen bg-cream" data-testid="auth-layout">
      <TopNavMenu />
      <SideNavMenu />
      <main
        className={classNames(
          sidebarMenuOpen ? "ml-56" : "ml-16",
          "mt-14 p-6 transition-all duration-200"
        )}
      >
        <Outlet />
      </main>
    </div>
  );
}
